<template>
  <div>
    <AppEditInventoriesDialog></AppEditInventoriesDialog>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      hide-actions
      class="elevation-1"
      :loading="loadingInProgress"
      :no-data-text="loadingItemsText"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.is_available }}</td>
        <td>{{ props.item.is_vendor }}</td>
        <td>{{ props.item.amount }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.updated_at }}</td>
        <td class="justify-left layout px-0">
          <v-btn icon class="mx-0" @click="editElement(props.item.id)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteDialog(props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
          <confirmation-dialog ref="confirm"></confirmation-dialog>
        </td>
      </template>
    </v-data-table>
    <AddInventoryButton/>
  </div>
</template>

<script>
  import AddInventoryButton from '@/components/buttons/AddInventoryButton'
  import AppEditInventoriesDialog from '@/components/dialogs/AppEditInventoriesDialog'
  import resourcesMixins from '@/mixins/Resources'
  import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'

  export default {
    name: 'Inventories',
    components: { AddInventoryButton, AppEditInventoriesDialog, ConfirmationDialog },
    mixins: [ resourcesMixins ],
    data () {
      return {
        resources: 'inventories',
        items: [],
        tableHeaders: [
          { text: 'ID', value: 'id' },
          { text: 'Name', value: 'name' },
          { text: 'Is available', value: 'is_available' },
          { text: 'Is external vendor', value: 'is_vendor' },
          { text: 'Amount', value: 'amount' },
          { text: 'Created at', value: 'created_at' },
          { text: 'Updated at', value: 'updated_at' },
          { text: 'Actions', value: 'actions' }
        ]
      }
    },
    methods: {
      deleteDialog (id) {
        this.$refs.confirm.open('Are you sure?', 'Delete', {}).then((confirm) => {
          this.deleteElement(id)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Inventories.vue?0317a4f8